<template>
    <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        width="40.000000" height="40.000000" fill="none">
        <rect id="svg" width="40.000000" height="40.000000" x="0.000000" y="0.000000" />
        <circle id="4897" cx="19.9996738" cy="20.0000401" r="16.666666" stroke="rgb(212,175,55)" stroke-linecap="round"
            stroke-linejoin="round" stroke-width="2.000000" />
        <path id="4898"
            d="M14.1064 13.9352C13.0752 17.9127 13.0752 22.0874 14.1064 26.0649C15.1376 30.0424 17.1659 33.6912 19.9997 36.6667C22.8335 33.6912 24.8618 30.0424 25.893 26.0649C26.9241 22.0874 26.9241 17.9127 25.893 13.9352C24.8618 9.95771 22.8335 6.30884 19.9997 3.33337C17.1659 6.30884 15.1376 9.95772 14.1064 13.9352Z"
            fill-rule="nonzero" stroke="rgb(212,175,55)" stroke-linecap="round" stroke-linejoin="round"
            stroke-width="2.000000" />
        <path id="4899" d="M3.33301 20L36.6663 20" stroke="rgb(212,175,55)" stroke-linecap="round"
            stroke-linejoin="round" stroke-width="2.000000" />
    </svg>
</template>